<template>
    <div class="listing-existing-cards-wrap">
        <div class="listing-cards section-wrap">
            <div class="heading-addcard-wrapper" :class="addNewCard ? 'flex-end' : ''" v-if="!loading">
                <div class="listing-heading" v-if="!addNewCard">
                    <div class="listing-heading-wrap">
                        <h5>{{ $ml.get("listingCards.title") }}:</h5>
                        <p>
                            <span v-if="hasCard">{{ $ml.get("listingCards.paragraph") }}</span>
                            <span v-if="!hasCard">{{ $ml.get("listingCards.paragraph2") }}</span>
                        </p>
                    </div>
                </div>
                <div class="add-credit-card" v-if="!addNewCard">
                    <button v-on:click="addNewBraintreeCard" class="primary-btn extra-small mobile">
                        Add Credit Card
                    </button>
                </div>
            </div>
            <div class="cards-wrap" v-if="!addNewCard && hasCard && braintreeCards.length > 0 && !loading">
                <div v-if="!loaded" class="cards-wrap">
                    <div v-for="(card, i) in braintreeCards" :key="`braintree-cards${i}`"
                        class="card-item card-item-wrap" :class="card.default ? 'default-card-background' : ''">
                        <!-- <pre>{{ card }}</pre> -->
                        <div class="radio-last4">
                            <input type="radio" name="payment-method" :id="`card-braintree-${i}`" v-model="selectedCard"
                                @change="setDefaultCard(card.payment_method_token)"
                                :value="card.payment_method_token" />
                            <div class="card-info-wrap hide-on-mobile">
                                <span class="info-label">Added on</span>
                                <span class="added-on">
                                    {{ dateCardAddedMonthDayYear(card.created_at) }} at
                                    {{ dateCardAddedHour(card.created_at) }}
                                </span>
                            </div>
                            <div class="card-info-wrap hide-on-mobile">
                                <span class="info-label">Expires on</span>
                                <span class="expires-on"> {{ card.expirationMonth }}/{{ card.expirationYear }}</span>
                            </div>
                            <div class="card-info-wrap hide-on-mobile">
                                <span class="info-label">Type</span>
                                <span class="card-type">{{ card.cardType }}</span>
                            </div>

                        </div>
                        <div class="card-delete-wrap">
                            <div class="card-info-wrap">
                                <label :for="`card-braintree-${i}`" class="default-card">
                                    <span class="info-label " v-if="card.default">Default card</span>
                                    <span class="info-label " v-if="!card.default">Set default card</span>
                                    <div class="card-last4">**** **** **** {{ card.last4 }}</div>
                                    <div class="card-brand">{{ card.brand }}</div>
                                </label>
                            </div>

                            <button type="button" class="remove primary-btn extra-small extra mobile"
                                @click="deleteBraintreeCard(card.payment_method_token)">
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
                <!--Loader-->
                <main-loader v-if="loaded || loading"></main-loader>
            </div>
            <div class="section-wrap no-credit-cards" v-if="cardsLoaded && braintreeCards.length === 0 && !addNewCard">
                You have no credit cards on file. <br />
                Please click “Add Credit Card” to add one in order to continue.
            </div>

            <div v-if="addNewCard">
                <div class="stripe-card-wrap">
                    <div>
                        <div class="card-form" ref="braintree_card"></div>
                        <div class="card-errors">{{ cardsErrors }}</div>
                        <div class="card-logos verified-secured-wrap" v-if="cardFormLoaded">
                            <div class="verified-secured"><img src="../../../assets/images/security.png" /></div>
                            <div class="ver-sec-text">Verified & Secured</div>
                        </div>

                    </div>
                    <div class="action-buttons-wrap">
                        <div>
                            <button v-on:click="saveCard" type="button" class="primary-btn extra-small mobile"
                                :disabled="loading">
                                {{ $ml.get("marketing.addCard") }}
                            </button>
                        </div>
                        <div>
                            <button v-on:click="cancelAddCard()" type="button" class="secondary-btn small mobile"
                                :disabled="loading">
                                {{ $ml.get("marketing.cancel") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <main-loader v-if="loading && !addNewCard"></main-loader>
        </div>
    </div>
</template>

<script>
import store from "../../../services/vuex";
import api from "../../../services/api_endpoints";
import eventBus from "../../../services/event_bus";
import messages from "../../../services/messages";
import MainLoader from "./main_loader.vue";
import moment from "moment";

export default {
    props: {
        waitingList: {
            type: Number,
            required: false,
        },
    },
    data() {
        return {
            hasCard: true,
            addNewCard: false,
            profile: {},
            braintreeCards: [],
            selectedCard: "",
            cardsErrors: "",
            loading: false,
            braintreeClientToken: "",
            loaded: false,
            cardsLoaded: false,
            addCardScreen: false,
            cardFormLoaded: false
        };
    },
    computed: {
        adminDetails: {
            get: function () {
                return store.state.adminDetails;
            },
            set: function (value) {
                store.commit("setAdminDetails", value);
            },
        },
        defaultCard: {
            get: function () {
                return store.state.defaultCard;
            },
            set: function (value) {
                store.commit("setDefaultCard", value);
            },
        },
    },
    mounted() {
        this.getStylistProfile();
        //check if adminDetails are either in store or loaded
        //if yes then do necessary logic
        if (store.state.adminDetails.user) {
            this.checkUserCard();
        }
        let self = this;
        eventBus.$on("admin_details_loaded", function () {
            self.checkUserCard();
        });
    },
    components: {
        MainLoader,
    },
    methods: {
        changeScreen(screen) {
            this.$emit("change-screen", screen);
        },
        getStylistProfile() {
            this.profile = this.adminDetails.profile;
        },
        checkUserCard() {
            this.loaded = true;

            this.$http
                .get(api.actions.get_braintree_customer_cards, { waiting_list: this.waitingList })
                .then((response) => {
                    if (response.data.error == true || !response.data.response.length) {
                        this.hasCard = false;
                        this.loaded = false;
                        this.checkNumberOfCards();

                        return;
                    }

                    this.hasCard = true;
                    this.braintreeCards = response.data.response;
                    this.checkDefaultCard();
                    this.cardsLoaded = true;
                    this.loaded = false;
                });
        },
        setDefaultCard(card_id) {
            this.loading = true;

            this.$http
                .post(api.actions.set_default_braintree_customer_card, {
                    payment_method_token: card_id,
                    waiting_list: this.waitingList,
                })
                .then(() => {
                    this.loading = false;
                    messages.successMessage(messages.GLOBAL_MESSAGES.GENERAL_SAVE);
                    this.checkDefaultCard(card_id);
                    this.checkUserCard();
                });
        },
        checkDefaultCard(card_id = "") {
            this.braintreeCards.forEach((card) => {
                if (card_id === card.payment_method_token) {
                    this.selectedCard = card.payment_method_token;
                    this.defaultCard = card;
                } else if (!card_id && card.default == true) {
                    this.selectedCard = card.payment_method_token;
                    this.defaultCard = card;
                }
            });
        },
        addNewBraintreeCard() {
            this.addNewCard = true;
            this.cardsErrors = "";

            if (!this.$refs.braintree_card) {
                setTimeout(() => {
                    this.addNewBraintreeCard();
                }, 100);
                return;
            }

            this.addCardScreenMethod();

            this.$http
                .get(api.actions.get_braintree_client_token, { waiting_list: this.waitingList })
                .then((response) => {
                    this.braintreeClientToken = response.data.client_token;

                    if (this.braintreeClientToken != '') {
                        setTimeout(() => {
                            this.cardFormLoaded = true;
                        }, 300);
                    }

                    window.braintree.dropin.create(
                        {
                            authorization: this.braintreeClientToken,
                            container: this.$refs.braintree_card,
                            card: {
                                overrides: {
                                    fields: {
                                        postalCode: {
                                            maxlength: 9, // Set the minimum length of the postal code field
                                        },
                                        expirationDate: {
                                            selector: "#expiration-date",
                                            placeholder: "MM/YY or MM/YYYY", // Sets placeholder to indicate MM/YY format
                                        },
                                    },
                                },
                            },
                        },
                        (error, dropinInstance) => {
                            if (!dropinInstance) {
                                return;
                            }

                            this.braintree_dropin_instance = dropinInstance;
                        }
                    );
                });


        },
        addCardScreenMethod() {
            this.$emit("add-card-screen", this.addNewCard);
        },
        saveCard() {
            this.loading = true;

            this.braintree_dropin_instance.requestPaymentMethod((error, payload) => {
                if (error) {
                    this.loading = false;
                    return false;
                }

                this.addNewCard = false;
                this.cardsErrors = "";

                this.$http
                    .post(api.actions.save_braintree_customer_card, {
                        payment_method_nonce: payload.nonce,
                        waiting_list: this.waitingList,
                    })
                    .then((result) => {
                        if (result.data.error) {
                            this.cardsErrors = result.data.message;
                            this.loading = false;
                            return;
                        } else {
                            this.hasCard = true;
                            this.checkUserCard();
                            this.addCardScreenMethod();
                            this.checkNumberOfCards();
                            this.setDefaultCard(result.body.payment_method_token);
                        }
                    });
            });
        },
        deleteBraintreeCard(card_id) {
            this.$swal({
                title: "Are you sure you want to delete the payment method?",
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.value) {
                    this.loading = true;

                    this.$http
                        .post(api.actions.delete_braintree_customer_cards, {
                            payment_method_token: card_id,
                            waiting_list: this.waitingList,
                        })
                        .then(() => {
                            this.loading = false;
                            this.checkNumberOfCards();
                            this.checkUserCard();
                        });
                }
            });
        },
        cancelAddCard() {
            this.addNewCard = false;
            this.cardFormLoaded = false;

            this.addCardScreenMethod();
        },
        checkNumberOfCards() {
            this.$emit("check-number-of-cards");
        },
        dateCardAddedMonthDayYear(cardDate) {
            // Ensure the date is in ISO 8601 format or handle parsing manually
            const date = new Date(cardDate.replace(/-/g, "/")); // Replace dashes with slashes for iOS compatibility
            const options = { month: "short", day: "numeric", year: "numeric" }; // Define format options
            const formattedDay = new Intl.DateTimeFormat("en-US", options).format(date);

            return formattedDay;
        },
        dateCardAddedHour(cardDate) {
            // Ensure the date is in ISO 8601 format or handle parsing manually
            const date = new Date(cardDate.replace(/-/g, "/")); // Replace dashes with slashes for iOS compatibility
            const options = { hour: "numeric", minute: "numeric", hour12: true }; // Define format options for time
            const formattedHour = new Intl.DateTimeFormat("en-US", options).format(date);

            return formattedHour;
        },
    },
};
</script>
